import styled from 'styled-components';

export const DropdownItem = styled.div<{ level: number }>`
    padding-left: ${({ level }) => (level ? 20 * level : 10)}px;
`;
